import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrescriptionListComponent } from './components/prescription-list/prescription-list.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonDetailsViewComponent } from 'src/app/shared/components/prescription-authorization-common/common-details-view/common-details-view.component';

const routes: Routes = [
  { path: 'prescriptionlist', component: PrescriptionListComponent},
  { path: 'detail-view/:id', component: CommonDetailsViewComponent},
  { path: '**', redirectTo: 'prescriptionlist' },
]

@NgModule({
  declarations: [
    PrescriptionListComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule,

  ],
  exports:[
    PrescriptionListComponent
  ],
})
export class PrescriptionModule { }
